<div class="flex justify-content-end" (click)="showPositionDialog()">
  <small>What is this? &nbsp;</small>
  <i class="pi pi-question-circle"> </i>
</div>
<div class="field-space-btwn">
  <div class="mt-4">
    <form [formGroup]="customizeDocumentForm">
      <formly-form [model]="model" [fields]="fields" [options]="options" [form]="customizeDocumentForm"></formly-form>
    </form>

    <div class="mt-4 text-right">
      <button
        label="Save"
        pButton
        type="button"
        icon="pi pi-plus"
        iconPos="left"
        (click)="customizeOrUpdateDocument(customizeDocumentForm)"
        [disabled]="!customizeDocumentForm.valid"
      ></button>
    </div>
  </div>
</div>
<p-dialog [(visible)]="displayGuide" position="topright" [modal]="true" [style]="{ width: '40vw' }">
  <img src="assets/images/screenshots/receipt-guide.png" alt="guide" width="90%" style="background-color: #ececf9; padding: 2rem" />
</p-dialog>
